module.exports = __webpack_public_path__ + "img/logo-swipe.bf918bae.svg";